module.exports = __webpack_public_path__ + "images/help_v2/avatars/yangxiong-16a5652f2b89fa793f115bcbf4fa9571.png";